import React from 'react'
import { GooSpinner } from 'react-spinners-kit'

const FallbackMode = () => (
  <div className="d-flex justify-content-center">
    <GooSpinner size={120} color="#2e353d" />
  </div>
)

export default FallbackMode